import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';

import Dialog from './Dialog';
import ProductTagsList from './../product/ProductTagsList';

class DialogProductTags extends React.Component {

  render () {
    const { classes, open, onClose, fullScreen, keepMounted, id_profile, ...others } = this.props;
    const id = "dialog-profile-product-tags-"+id_profile;
    return (
      <Dialog
        keepMounted={keepMounted}
        id={id}
        fullScreen={fullScreen}
        open={open}
        onClose={onClose}
        title="Tags de produit"
      >
        <ProductTagsList
          scrollableTarget={id}
          id_profile={id_profile}
          hideTitle={true}
          {...others}
        />
      </Dialog>
    )
  }
}

const styles = theme => ({});

DialogProductTags.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

export default withStyles(styles, { withTheme: true })(DialogProductTags);
